document.addEventListener("DOMContentLoaded", function () {
  console.log("Quickbuy script loaded!"); // Bekræfter at scriptet kører

  // Opdater variant-id på knappen, når en variant vælges
  document.body.addEventListener("change", function (event) {
    let variantSelect = event.target.closest(".variant-select");
    if (variantSelect) {
      event.preventDefault(); // Stopper Shopify fra at navigere væk
      event.stopPropagation();

      let productId = variantSelect.getAttribute("data-product-id");
      let selectedVariantId = variantSelect.value;

      let addToCartBtn = document.querySelector(
        `.quick-add-to-cart-btn[data-product-id="${productId}"]`
      );
      if (addToCartBtn) {
        addToCartBtn.setAttribute("data-variant-id", selectedVariantId);
        console.log(
          `✅ Variant opdateret for produkt ${productId}: ${selectedVariantId}`
        );
      } else {
        console.error("❌ Kunne ikke finde knappen for produktet.");
      }
    }
  });

  // Håndter klik på "Tilføj" knappen og send den valgte variant til Shopify's cart API
  document.body.addEventListener("click", function (event) {
    let quickAddBtn = event.target.closest(".quick-add-to-cart-btn");

    if (quickAddBtn) {
      event.preventDefault();
      let variantId = quickAddBtn.getAttribute("data-variant-id");

      if (!variantId) {
        console.error(
          "❌ Variant ID mangler! Standard variant bruges i stedet."
        );
        return;
      }

      console.log(`🛒 Forsøger at tilføje variant ${variantId} til kurven...`);

      let formData = {
        id: variantId,
        quantity: 1,
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("✅ Produkt tilføjet til kurven:", data);
          document.dispatchEvent(new CustomEvent("theme:open-cart-drawer"));
          document.dispatchEvent(new CustomEvent("theme:cartchanged"));
        })
        .catch((error) => {
          console.error("❌ Fejl ved tilføjelse til kurv:", error);
        });
    }
  });
});

  window.addEventListener('DOMContentLoaded', function () {
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('da-DK', {
        style: 'currency',
        currency: 'DKK'
      });
    }

document.body.addEventListener("change", function (e) {
  const select = e.target.closest(".variant-select");
  if (!select) return;

  const variantId = select.value;
  const productId = select.dataset.productId;

  let product = window.ProductData?.[productId];
  if (!product) {
    const el = document.querySelector(`[data-product-id="${productId}"]`);
    if (el && el.dataset.productJson) {
      try {
        product = JSON.parse(el.dataset.productJson);
        window.ProductData = window.ProductData || {};
        window.ProductData[productId] = product;
      } catch (e) {
        console.error("❌ Kunne ikke parse JSON:", e);
        return;
      }
    }
  }

  const variant = product.variants.find(v => v.id == variantId);
  if (!variant) return;

  const formatMoney = (cents) =>
    (cents / 100).toLocaleString("da-DK", {
      style: "currency",
      currency: "DKK",
    });

  const priceEl = document.querySelector(
    `[data-price][data-product-id="${productId}"]`
  );
  if (priceEl) priceEl.textContent = formatMoney(variant.price);

  const comparePriceEl = document.querySelector(
    `[data-compare-at-price][data-product-id="${productId}"]`
  );
  if (comparePriceEl) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      comparePriceEl.style.display = "inline";
      comparePriceEl.textContent = formatMoney(variant.compare_at_price);
    } else {
      comparePriceEl.style.display = "none";
    }
  }

  // Opdater variant-id på tilføj-knappen (hvis den findes)
  const addToCartBtn = document.querySelector(
    `.quick-add-to-cart-btn[data-product-id="${productId}"]`
  );
  if (addToCartBtn) {
    addToCartBtn.setAttribute("data-variant-id", variantId);
  }
});

  });


/* ------------------------------------------------------------------
 * Neutralize the theme's nav-hover state.
 *
 * theme.js attaches mouseenter/mouseleave listeners that toggle
 *   .section-header--nav-hover
 * on the .section-header element. The theme uses that class with the
 *   :not(.section-header--nav-hover)
 * pattern to STOP applying the transparent-header white-text rules
 * the moment a user hovers a nav link, flipping all nav text + icons
 * to the configured `head_txt_col` / `font_col_nav_hov` (black on
 * this site).
 *
 * We can't easily un-attach the theme's listeners (they hold a stale
 * function reference), so instead we observe class attribute mutations
 * on every .section-header element and immediately strip the class the
 * instant it's added. The CSS overrides in custom.css.liquid would
 * already keep the nav white, but stripping the class is the surest
 * defense — it neutralizes the entire mechanism, including the
 * `+ #main-nav` cascade and any future rules keyed off the class.
 * ------------------------------------------------------------------ */
(function(){
  var TAG = '[nav-hover-killswitch]';
  var KILL_CLASSES = ['section-header--nav-hover', 'section-header--nav-open'];

  function stripFrom(el){
    if(!el || !el.classList) return;
    KILL_CLASSES.forEach(function(cls){
      if(el.classList.contains(cls)) el.classList.remove(cls);
    });
  }

  function arm(el){
    stripFrom(el);
    var obs = new MutationObserver(function(muts){
      muts.forEach(function(m){
        if(m.type === 'attributes' && m.attributeName === 'class'){
          stripFrom(m.target);
        }
      });
    });
    obs.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function init(){
    var headers = document.querySelectorAll('.section-header');
    console.log(TAG, 'arming on', headers.length, 'header(s)');
    headers.forEach(arm);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Search overlay: handled by raising #shopify-section-header's z-index
   to 9999 directly in theme.liquid (so it permanently sits above
   .page-shade at 7000). No JS needed — the theme's existing show/hide
   flow takes care of the rest, and the live-search binding stays intact
   because the element lives in its original DOM position. */

